module.exports = __webpack_public_path__ + "img/audio.9463f098.png";